module.exports = __webpack_public_path__ + "zvetseni-prsou_53_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_53_after.jpg
// module id = 1347
// module chunks = 0